var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-space-between container"},[(_vm.isIf)?_c('list',{ref:"indexList"}):_vm._e(),(!_vm.isIf)?_c('div',{staticStyle:{"width":"100%"}},[(!_vm.isIf)?_c('deail',{attrs:{"operate":_vm.operate,"edits":_vm.edits}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }